(function (angular) {
    /**
    * Directive to broadcast when the enter button has been pressed
    */
    angular.module('app')
        .directive('compile', ['$compile', function($compile) {
          return function(scope, element, attrs) {
            scope.$watch(
              function(scope) {
                return scope.$eval(attrs.compile);
              },
              function(value) {
                element.html(value);
                $compile(element.contents())(scope);
              }
           )};
        
        }]);
})(angular);